import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Col,
  Container,
  Form,
  Nav,
  Row,
  Tab,
  Spinner,
  Button,
  Alert,
  Modal,
} from "react-bootstrap";
import ProjectDetails from "./projectDetails";
import Milestones from "./milestones";
import HicSubcontractAgreements from "./hicSubcontractAgreements";
import { jwtDecode } from "jwt-decode";
import Contract from "./contract";
import { Link } from "react-router-dom";
import {
  getSingleProjectById,
  getHomeownerContractsById,
  getSubscribedUser,
  createProject,
  updateProject,
  createMileStones,
  searchHomeOwner,
  getHomeOwnerById,
} from "../../../../slices/thunk";
import { resetState } from "../../../../slices/contract/reducer";
import NonEscrowMilestones from "./non-escrow-milestones";
import Tutorial from "./tutorial";

import { useTour } from "@reactour/tour";
import { useTranslation } from "react-i18next";
import { getDecodeId, getUserType } from "slices/userProfile/thunk";
import NewNonEscrow from "./newMilstones";
import { Toaster, toast } from "sonner";
import { AlertCircle, CheckCircle2, ClipboardCheck, FileText, Loader2, Send, Sparkles, UserRound, UsersRound } from "lucide-react";
import { cleanMoney } from "components/AddMilestoneDialog";
import { getDecodeUserType } from "slices/auth/login/thunk";
import { ProfileCompletionGate } from "./ProfileCompletionGate";
import { CallAPIGetPromise } from "Common/commaon";
import { canAccessContractRecord, hasContractPermission, isHomeownerContractOwner } from "Common/permissions";
import { PERMISSIONS } from "Common/constants/permissions";
import { isContractProfileTestUserEmail } from "utils/contractProfileTestUser";
import { clearLoganProjectDraft, loadLoganProjectDraft, LoganProjectDraft, saveLoganProjectDraft, saveLoganProjectScope } from "features/productAssistant/projectDraft";
import { ContractWorkflowChange } from "features/productAssistant/productAssistant.api";
import ContractAssistantRail, { ContractHomeownerMatch } from "./ContractAssistantRail";

interface CreateProjectProps {}
interface JwtPayload {
  userType: string;
}
interface Milestone {
  id: any;
  title: string;
  name: string;
  percentage: number;
  isDisable: boolean;
  inspectionUrl: string;
  isCompleted: boolean;
  status: string;
}

const CreateProject: React.FC<CreateProjectProps> = () => {
  const dispatch: any = useDispatch();
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }
  const { t } = useTranslation(); // ✅ React knows to update
  let project: any = null;
  project = useSelector((state: any) => state.Contract.project);
  const [homeOwnerId, setHomeOwnerId] = useState<any>("");
  const [refresh,setRefresh]= useState(false)

  const [formData, setFormData] = useState({  projectName: project && project.p_name ? project.p_name : "",
  country: project && project.p_country ? project.p_country : "",
  address:
    project && project.p_street_address ? project.p_street_address : "",
  city: project && project.p_city ? project.p_city : "",
  state: project && project.p_state ? project.p_state : "",
  zip: project && project.p_zip ? project.p_zip : "",
  firstName:
    project && project.home_owner && project.home_owner.user_first_name
      ? project.home_owner.user_first_name
      : "",
  lastName:
    project && project.home_owner && project.home_owner.user_last_name
      ? project.home_owner.user_last_name
      : "",
  email:
    project && project.home_owner && project.home_owner.user_email
      ? project.home_owner.user_email
      : "",
  phone:
    project && project.home_owner && project.home_owner.user_phone
      ? project.home_owner.user_phone
      : "",
  costOfProject: project && Number(project.p_cost) ?.toLocaleString('en-US', { minimumFractionDigits: 2 }) ?Number(project.p_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2 }) : "",
  escrow: project && project.p_escrow == 1 ? true : false,});

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const initialProjectId = searchParams.get("id") || "";
  const isLoganDraftNavigation = searchParams.get("loganDraft") === "1";
  const isLoganChatNavigation = searchParams.get("logan") === "chat";
  const navigationState = location.state as {
    focusLoganChat?: boolean;
    loganContractContext?: string;
    loganProjectDraft?: LoganProjectDraft;
  } | null;
  const stateLoganDraft = navigationState?.loganProjectDraft;
  const loganContractContext = String(navigationState?.loganContractContext || "").trim();
  const shouldFocusLoganChat = isLoganChatNavigation || navigationState?.focusLoganChat === true;
  const [storedLoganDraft] = useState<LoganProjectDraft | null>(() => loadLoganProjectDraft());
  const loganNavigationDraft = !initialProjectId && isLoganDraftNavigation
    ? stateLoganDraft || storedLoganDraft || undefined
    : undefined;
  const [assistantScope, setAssistantScope] = useState(loganNavigationDraft?.scope || "");
  const [error,setError] = useState("")
  const [contractValue, setContractValue] = useState('0');

  const [successmsg,setSuccessMsg] = useState("")
  const [bluePrintUrl, setBluePrintUrl] = useState<any>(
    project && project.p_blue_print ? project.p_blue_print : ""
  );
  const [missingFields, setMissingFields] = useState<string[]>([]);
  const [milestones, setMilestones] = useState<Milestone[]>([]);
  const [milestoneLoading,setMilestoneLoading] = useState(false)
  const [contData, setContData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [projectLoading,setPojectLoading] =useState(false)
  const [workspaceLoading, setWorkspaceLoading] = useState(Boolean(initialProjectId));
  const loadedWorkspaceProjectIdRef = useRef("");
  const loganDraftAppliedRef = useRef(false);
  const loganDraftRef = useRef<LoganProjectDraft | undefined>(loganNavigationDraft);
  const projectSubmissionRef = useRef(false);
  const projectUpdateSubmissionRef = useRef(false);
  const pendingProfileActionRef = useRef<null | (() => void)>(null);
  const [projectLoadError, setProjectLoadError] = useState("");
  const [newUserType, setNewUserType] = useState<any>(false);
  const [projectId, setProjectId] = useState<any>(initialProjectId);
  const [activeArrowTab, setActiveArrowTab] = useState(1);
  const [assistantExpanded, setAssistantExpanded] = useState(() => shouldFocusLoganChat || localStorage.getItem("loganContractRail.expanded") !== "false");
  const [contractEditorOpen, setContractEditorOpen] = useState(false);
  const [contractTermsSnapshot, setContractTermsSnapshot] = useState<Partial<LoganProjectDraft>>({});
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [linkedSubcontractAgreements, setLinkedSubcontractAgreements] = useState<any[]>([]);
  const [showProfileWarning, setShowProfileWarning] = useState(false);
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);
  const userType = getUserType()
  const isContractorUser = userType === "contractor" || userType === "testContractor";
  const isInspectorUser = userType === "inspector";
  const isContractProfileTestUser = Boolean(decoded?.isContractProfileTestUser)
    || isContractProfileTestUserEmail(decoded?.email);
  const isProfileBlocking = Boolean(missingFields.length) && !isContractProfileTestUser;
  const handleContractAssistantSnapshotChange = useCallback((snapshot: Partial<LoganProjectDraft>) => {
    setContractTermsSnapshot((current) => {
      const next = { ...current, ...snapshot };
      return JSON.stringify(next) === JSON.stringify(current) ? current : next;
    });
  }, []);

  useEffect(() => {
    if (activeArrowTab !== 4 && contractEditorOpen) {
      setContractEditorOpen(false);
    }
  }, [activeArrowTab, contractEditorOpen]);

  useEffect(() => {
    if (!project?.p_id) return;
    setContractTermsSnapshot({
      governingState: project?.contract?.pc_state || "",
      additionalHomeownerName: project?.contract?.pc_additional_home_owner_name || "",
      startDate: toDateInputValue(project?.contract?.pc_start_date),
      substantialCompletionDate: toDateInputValue(project?.contract?.pc_substantial_completion_date),
      endDate: toDateInputValue(project?.contract?.pc_completion_date),
      projectCostModel: project?.contract?.pc_project_cost_model || "",
      allowances: String(project?.contract?.pc_total_allowance || ""),
      descriptionOfWork: project?.contract?.pc_work_description || assistantScope || "",
      contractorAuthorizedRepresentative: project?.contract?.pc_contractor_authorized_representative || "",
      homeownerAuthorizedRepresentative: project?.contract?.pc_homeowner_authorized_representative || "",
      contractorInsurance: project?.contract?.pc_contractor_insurance_option || "",
      insuranceProviderName: project?.contract?.pc_contractor_insurance_provider_name || "",
      workersCompensationInsurance: project?.contract?.pc_worker_compensation_insurance_option || "",
      workersCompensationInsuranceLimit: project?.contract?.pc_worker_compensation_insurance_limit || "",
      documentName: project?.p_name || "",
    });
  }, [project?.p_id]);

  useEffect(() => {
    if (initialProjectId || loganDraftAppliedRef.current) return;
    const loganDraft = loganNavigationDraft;
    if (!loganDraft) return;

    loganDraftAppliedRef.current = true;
    loganDraftRef.current = loganDraft;
    setAssistantScope(loganDraft.scope || "");
    if (loganDraft.homeownerId) setHomeOwnerId(loganDraft.homeownerId);
    if (loganDraft.costOfProject) setContractValue(loganDraft.costOfProject);
    if (loganDraft.milestones?.length) {
      setMilestones(toWorkflowMilestones(loganDraft.milestones, loganDraft.costOfProject));
    }
    setFormData((current) => ({
      ...current,
      projectName: loganDraft.projectName || current.projectName,
      country: loganDraft.country || current.country,
      address: loganDraft.address || current.address,
      city: loganDraft.city || current.city,
      state: loganDraft.state || current.state,
      zip: loganDraft.zip || current.zip,
      firstName: loganDraft.homeownerFirstName || current.firstName,
      lastName: loganDraft.homeownerLastName || current.lastName,
      email: loganDraft.homeownerEmail || current.email,
      phone: loganDraft.homeownerPhone || current.phone,
      costOfProject: loganDraft.costOfProject || current.costOfProject,
      escrow: loganDraft.escrow,
    }));
  }, [initialProjectId, loganNavigationDraft]);

  const updateCompanyProfile = () => {
    setShowProfileWarning(false);
    pendingProfileActionRef.current = null;
    navigate("/pages-profile-settings#companyDetails");
  };

  const runWithProfileWarning = (action: () => void) => {
    if (isContractProfileTestUser && missingFields.length) {
      pendingProfileActionRef.current = action;
      setShowProfileWarning(true);
      return;
    }

    action();
  };

  const continueAfterProfileWarning = () => {
    const pendingAction = pendingProfileActionRef.current;
    pendingProfileActionRef.current = null;
    setShowProfileWarning(false);
    pendingAction?.();
  };

  const dismissProfileWarning = () => {
    pendingProfileActionRef.current = null;
    setShowProfileWarning(false);
  };


  useEffect(() => {
    if (notification && notification.status) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);

      // Cleanup the timeout if the component unmounts or notification changes
      return () => clearTimeout(timer);
    }
  }, [notification]);

  useEffect(() => {
    setLoading(true);
    dispatch(getSubscribedUser())
      .then((resp: any) => {
        setTermsAccepted(resp?.subscription?.cpp_is_active === "ACTIVE");
      })
      .catch(() => {
        setTermsAccepted(false);
        setNotification({
          status: true,
          message: "Subscription status could not be loaded. You can retry by refreshing the page.",
          variant: "warning",
        });
      })
      .finally(() => setLoading(false));
  }, [dispatch]);

  const userSubscribed = useSelector(
    (state: any) => state.UserProfile.subscribedData
  );

  const handleAlertClick = () => {
    setNotification(null);
  };
 useEffect(()=>{
  if(!isContractorUser){
    setMissingFields([]);
    return;
  }
CallAPIGetPromise(`/company/get-company/${getDecodeId()}`).then((res:any)=>{
  if (res?.data?.length) {
    const company = res.data[0];

    const missing: string[] = [];

    if (!company?.cc_company_name) {
      missing.push("Company Name");
    }

    if (!company?.cc_licence_documentation_url) {
      missing.push("W-9 Document");
    }
    if (!company?.cc_insurance_documentation_url) {
      missing.push("Insurance Document");
    }
    if (!company?.cc_contractor_documentation_url) {
      missing.push("Contractor License Document");
    }
 console.log(missing)
 console.log(company)
    setMissingFields(missing);
  } else {
    // if no company record found, treat as missing
    setMissingFields(["Company Name", "Contractor License"]);
  }
})
 },[isContractorUser])

  useEffect(() => {
    document.title = "Tradesmen Admin";

    const token = localStorage.getItem("authUser");
    let decoded: any = "";

    if (token !== null) {
      try {
        decoded = jwtDecode<JwtPayload>(token);
        if (
          decoded &&
          decoded.userType !== "contractor" &&
          decoded.userType !== "testContractor"
        ) {
          setNewUserType(true);
        } else {
          setNewUserType(false);
        }
      } catch (error) {
        console.error("Failed to decode token:", error);
      }
    } else {
      console.error("Token is null");
    }

    if (project && project.p_status === "LIVE") {
      setNewUserType(true);
    }
  }, [project]);
  let nestedParams: any = null;
  useEffect(() => {
    if (!location.search) {
      console.log("No search parameters found");
      return;
    }
    const id = searchParams ? searchParams.get("id") : null;
    setProjectId((currentProjectId: any) => {
      if (String(currentProjectId || "") !== String(id || "")) {
        setWorkspaceLoading(Boolean(id));
        loadedWorkspaceProjectIdRef.current = "";
      }
      return id || "";
    });
 
  }, [location.search, searchParams]);
  useEffect(() => {
    if (projectId !== "") {
      const shouldBlockWorkspace = loadedWorkspaceProjectIdRef.current !== String(projectId);
      if (shouldBlockWorkspace) {
        setWorkspaceLoading(true);
        setProjectLoadError("");
      }
      dispatch(getSingleProjectById(projectId))
        .then((loadedProject: any) => {
          if (!loadedProject) {
            if (shouldBlockWorkspace) {
              setProjectLoadError("We couldn't load this contract. Please try again.");
            }
            return;
          }
          loadedWorkspaceProjectIdRef.current = String(projectId);
          const tab = searchParams ? searchParams.get("tab") : null;
          const tab2 = nestedParams ? nestedParams.get("id") : null;
          const tabMap: Record<string, number> = {
            "Project-Details": 1,
            "Project-Milestones": 2,
            Subcontractor: 3,
            "Homeowner-Contract": 4,
            Finish: 5,
          };
          if (tab && tabMap[tab]) {
            const tabId = tabMap[tab];
            if (isInspectorUser && ![1, 2, 5].includes(tabId)) {
              const action = searchParams.get("action");
              setActiveArrowTab(1);
              navigate(`${location.pathname}?tab=Project-Details&id=${projectId}&action=${action || 1}`, { replace: true });
              return;
            }
            setActiveArrowTab(tabId);
          }
          if(!isInspectorUser && tab ==="Homeowner-Contract"){
            onCreateProject(4,projectId)
          }
          if(!isInspectorUser && tab ==="Subcontractor"){
            onCreateProject(3,projectId)
          }
        })
        .finally(() => {
          if (shouldBlockWorkspace) {
            setWorkspaceLoading(false);
          }
        }
      );
     
    } else {
      dispatch(resetState());
      setPojectLoading(false);
    }
  }, [dispatch, projectId,refresh,isInspectorUser,navigate,location.pathname]);


  const handleCreateProject = (allowIncompleteProfile = false) => {
    if (projectSubmissionRef.current || projectLoading) return;
    console.log("sas")
    console.log(!hasContractPermission(PERMISSIONS.CREATE_CONTRACT))
    if ((decoded.userType === "contractor" ) && !hasContractPermission(PERMISSIONS.CREATE_CONTRACT)) {
      setError("You do not have permission to create contracts");
      setTimeout(() => setError(""), 5000);
      return;
    }
    if(missingFields[0] && !(isContractProfileTestUser && allowIncompleteProfile)){
      if (isContractProfileTestUser) {
        runWithProfileWarning(() => handleCreateProject(true));
      }
      console.log("s")

      window.scrollTo({ top: 0, behavior: "smooth" });
      return 
    }
    if(!formData.projectName){
      setError('Project name required')
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // optional for smooth animation
      });
  setTimeout(() => {
        setError('')
     
  }, 5000);
  return
    }
    if(!formData.zip){
      setError('Zip required')
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // optional for smooth animation
      });
  setTimeout(() => {
        setError('')
     
  }, 5000);
  return
    }
    if(!formData.city){
      setError('City required')
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // optional for smooth animation
      });
  setTimeout(() => {
        setError('')
     
  }, 5000);
  return
    }
    if(!formData.address){
      setError('Address required')
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // optional for smooth animation
      });
  setTimeout(() => {
        setError('')
     
  }, 5000);
  return
    }

    if(!homeOwnerId){
      setError('Homeowner details required')
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // optional for smooth animation
      });
  setTimeout(() => {
        setError('')
     
  }, 5000);
  return
    }


    if(!formData.costOfProject){
      setError('Cost of project required')
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // optional for smooth animation
      });
  setTimeout(() => {
        setError('')
     
  }, 5000);
  return
    }

    projectSubmissionRef.current = true;
    setPojectLoading(true);
    let projectDetails = {
      projectName: formData.projectName,
      projectStatus: "DRAFT",
      projectHomeOwnerId: homeOwnerId,
      projectContractorId: decoded.userId,
      projectCountry: formData.country,
      projectStreetAddress: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      cost: formData.costOfProject ,
      escrow: formData.escrow,
      bluePrint: bluePrintUrl,
      scopeOfWork: assistantScope,
      workDescription: assistantScope,
      userId: decoded.userId,
    };
    return dispatch(createProject(projectDetails))
      .then((resp: any) => {
        const createdProjectId = resp?.result?.insertId;
        if (!createdProjectId) throw new Error("Project creation did not return a project ID.");
        if (assistantScope) {
          saveLoganProjectScope(createdProjectId, assistantScope);
        }
        if (loganDraftAppliedRef.current) clearLoganProjectDraft();
        onCreateProject(2, createdProjectId);
        setNotification({
          status: true,
          message: "Project Created Successfully",
          variant: "success",
        });
      })
      .catch((error: any) => {
        console.error("Error creating project:", error);
        setError("Project could not be created. Please review the details and try again.");
        setNotification({
          status: true,
          message: "Project could not be created. Please try again.",
          variant: "danger",
        });
        setTimeout(() => setError(""), 5000);
      })
      .finally(() => {
        projectSubmissionRef.current = false;
        setPojectLoading(false);
      });
  };

  const handleUpdateProject = (allowIncompleteProfile = false) => {
    if (projectUpdateSubmissionRef.current || projectLoading) return;
    if ((decoded.userType === "contractor" || decoded.userType === "testContractor") && !canAccessContractRecord(project, PERMISSIONS.UPDATE_CONTRACT)) {
      setError("You do not have permission to update this contract");
      setTimeout(() => setError(""), 5000);
      return;
    }
    if(missingFields[0] && !(isContractProfileTestUser && allowIncompleteProfile)){
      if (isContractProfileTestUser) {
        runWithProfileWarning(() => handleUpdateProject(true));
      }
      console.log("s")
      window.scrollTo({ top: 0, behavior: "smooth" });

      return 
    }
    if(isEditDisable){
      onCreateProject(2, projectId);
return
    }

    const resolvedHomeOwnerId = homeOwnerId || project?.home_owner?.user_id;
    const resolvedProjectId = projectId || project?.p_id;

    if(!formData.projectName || !resolvedHomeOwnerId || !decoded.userId || !resolvedProjectId){
      setError("Complete the required project details before continuing");
      setTimeout(() => setError(""), 5000);
      return 

    }
    projectUpdateSubmissionRef.current = true;
    setPojectLoading(true);
    let projectDetails = {
      projectName: formData.projectName,
      projectStatus:project?.p_status||"DRAFT",
      projectHomeOwnerId: resolvedHomeOwnerId,
      projectContractorId: decoded.userId,
      projectCountry: formData.country,
      projectStreetAddress: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      cost:cleanMoney(formData.costOfProject) ,
      escrow: formData.escrow,
      bluePrint: bluePrintUrl,
      scopeOfWork: assistantScope,
      workDescription: assistantScope,
      userId: decoded.userId,
      projectId: resolvedProjectId,
    };
    return dispatch(updateProject(projectDetails))
      .then((resp: any) => {
        if (!resp) throw new Error("Project update failed.");
        onCreateProject(2, resolvedProjectId);
        setRefresh(r=>!r)
        setNotification({
          status: true,
          message: "Project Updated Successfully",
          variant: "success",
        });
      })
      .catch((error: any) => {
        console.error("Error creating project:", error);
        setError("Project could not be updated. Please try again.");
        setTimeout(() => setError(""), 5000);
      })
      .finally(() => {
        projectUpdateSubmissionRef.current = false;
        setPojectLoading(false);
      });
  };
  const normalizeTabForRole = (tabId: number) => {
    if (isInspectorUser && ![1, 2, 5].includes(tabId)) {
      return 1;
    }

    return tabId;
  };

  const onCreateProject = (newTab: number, id: any) => {
  
    const nextTab = normalizeTabForRole(newTab);
    setActiveArrowTab(nextTab);
    const action = searchParams.get("action")
    const tabName = getTabName(nextTab);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", tabName);
    nextParams.set("id", id || projectId || "");
    nextParams.set("action", action || "1");
    navigate(`${location.pathname}?${nextParams.toString()}`);
  };
  const gotoProjectPage=(newTab:any)=>{
    setActiveArrowTab(newTab);
    const action = searchParams.get("action")
    const tabName = getTabName(1);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", tabName);
    nextParams.set("id", projectId || "");
    nextParams.set("action", action || "1");
    navigate(`${location.pathname}?${nextParams.toString()}`);
  }

  const getTabName = (tabId: number) => {
    switch (tabId) {
      case 1:
        return "Project-Details";
      case 2:
        return "Project-Milestones";
      case 3:
        return "Subcontractor";
      case 4:
        return "Homeowner-Contract";
      case 5:
        return "Finish";
      default:
        return "";
    }
  };
  const {setSteps,setIsOpen} = useTour()
const handleMilestoneSubmit = async (number?:any, allowIncompleteProfile = false) => {
  if ((decoded.userType === "contractor" || decoded.userType === "testContractor") && !canAccessContractRecord(project, PERMISSIONS.UPDATE_CONTRACT)) {
    setError("You do not have permission to update this contract");
    setTimeout(() => setError(""), 5000);
    return;
  }
  if (missingFields[0] && isContractProfileTestUser && !allowIncompleteProfile) {
    runWithProfileWarning(() => handleMilestoneSubmit(number, true));
    return;
  }
  if(!project){
    return
  }
  if(isEditDisable || (activeArrowTab !==2&& projectId) ){
    onCreateProject(4, projectId)
    return
  }
  if(milestoneLoading){
    setError( "Milestones loading..")
  setTimeout(() => {
    setError("")
  }, 5000);
    return
  }
  if(!projectId){
  setError( "Please create project first")
  setTimeout(() => {
    setError("")
  }, 5000);
  return
  }


  const totalPercentage = milestones.reduce(
    (total:any, milestone:any) => total + Number(milestone.percentage) ,
    0
  );
if(totalPercentage <100){
  setError("Milestones total must be equal to 100%")
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // optional for smooth animation
  });
setTimeout(() => {
    setError("")
}, 5000);
  return
}
if(totalPercentage >100){
  setError("Milestones total cannot be greater than 100%")
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // optional for smooth animation
  });
setTimeout(() => {
    setError("")
}, 5000);
  return
}
  const formDataJSON = {
    projectId: projectId,
    totalCost: cleanMoney(contractValue) ,
    milestones: milestones,
  };
  setMilestoneLoading(true)
  try {
    await dispatch(createMileStones(formDataJSON));
    if (project !== "") {
      await dispatch(getSingleProjectById(project.p_id));
    }
    onCreateProject(userType === "homeowner" ? 4 : (number || 4), projectId)
    setNotification({
      status: true,
      message: "Milestones Created Successfully",
      variant: "success",
    });
  } catch (_error) {
    setError("Milestones could not be saved. Review the payment plan and try again.");
    setNotification({
      status: true,
      message: "Milestones could not be saved.",
      variant: "danger",
    });
    setTimeout(() => setError(""), 5000);
  } finally {
    setMilestoneLoading(false)
  }
};

useEffect(()=>{
  // A new Logan-assisted project has already populated the form. The contract
  // reducer is reset while opening this page, so do not replace that draft with
  // an empty project during the reset.
  if (!projectId && loganDraftRef.current) return;

  setFormData({  projectName: project && project.p_name ? project.p_name : "",
  country: project && project.p_country ? project.p_country : "",
  address:
    project && project.p_street_address ? project.p_street_address : "",
  city: project && project.p_city ? project.p_city : "",
  state: project && project.p_state ? project.p_state : "",
  zip: project && project.p_zip ? project.p_zip : "",
  firstName:
    project && project.home_owner && project.home_owner.user_first_name
      ? project.home_owner.user_first_name
      : "",
  lastName:
    project && project.home_owner && project.home_owner.user_last_name
      ? project.home_owner.user_last_name
      : "",
  email:
    project && project.home_owner && project.home_owner.user_email
      ? project.home_owner.user_email
      : "",
  phone:
    project && project.home_owner && project.home_owner.user_phone
      ? project.home_owner.user_phone
      : "",
  costOfProject: project &&project.p_cost?Number(project.p_cost).toLocaleString('en-US', { minimumFractionDigits: 2})  : "",
  escrow: project && project.p_escrow == 1 ? true : false,})
  setBluePrintUrl( project && project.p_blue_print ? project.p_blue_print : "")
  setContractValue(project?.p_total_cost ? Number(project.p_total_cost) ?.toLocaleString('en-US', { minimumFractionDigits: 2}): "")
  setAssistantScope(project?.p_scope_of_work || project?.p_work_description || project?.contract?.pc_work_description || "")
},[project?.p_id,project?.p_total_cost,projectId])
const isEscrowProject = Number(project?.p_escrow )===1
useEffect(()=>{
if(Number(project?.p_escrow )===1){
  setMilestones(()=>{
    if (project && project.milestones.length) {
      const baseAmount = parseFloat(
        project.p_total_cost||0
      );

      return project.milestones.map((milestone: any, index: number) => ({
        id: milestone.pm_id,
        name: milestone.pm_name,
        percentage: milestone.pm_percentage,
        amount:  baseAmount * (parseFloat(milestone.pm_percentage) || 0) / 100,
        status:milestone.pm_status,
        description:milestone.pm_description,
        workStage:milestone.pm_work_stage,
        inspectionImages:[],
        inspectionStatus:"",
        pm_inspection_details:milestone.pm_inspection_details,
        inspectionDisapprovalReason:"",
        activities:milestone.activities.map((a:any)=>{
          return {
            id: a.pma_id,
            timestamp:a.pma_timestamp,
            user: a.pma_role,
            role: a.pma_role,
            action: a.pma_action.replace('_'," ").replace("_"," "),
            details: a.pma_details,
            image:a?.pma_related_images||[]
          }
        }),
        
      }));
    } else {
      if (loganDraftRef.current?.milestones?.length) {
        return toWorkflowMilestones(loganDraftRef.current.milestones, project?.p_total_cost || loganDraftRef.current.costOfProject);
      }
      return [
        {
          id: `t-${Date.now()}-1`,
          name: 'Milestone 1',
          percentage: 10,
          amount: (project.p_total_cost || 0) * 0.10,
          status: 'pending',
          description: 'Initial setup and groundwork before starting the main task.',
          workStage: 'not-started',
          inspectionImages: [],
          inspectionStatus: '',
          pm_inspection_details: {},
          inspectionDisapprovalReason: '',
          activities: [],
        },
        {
          id: `t-${Date.now()}-2`,
          name: 'Milestone 2',
          percentage: 30,
          amount: (project.p_total_cost || 0) * 0.30,
          status: 'pending',
          description: 'Execution of the main task and steady progress toward completion.',
          workStage: 'not-started',
          inspectionImages: [],
          inspectionStatus: '',
          pm_inspection_details: {},
          inspectionDisapprovalReason: '',
          activities: [],
        },
        {
          id: `t-${Date.now()}-3`,
          name: 'Milestone 3',
          percentage: 30,
          amount: (project.p_total_cost || 0) * 0.30,
          status: 'pending',
          description: 'Continuation and refinement of work to ensure consistency and completion.',
          workStage: 'not-started',
          inspectionImages: [],
          inspectionStatus: '',
          pm_inspection_details: {},
          inspectionDisapprovalReason: '',
          activities: [],
        },
        {
          id: `t-${Date.now()}-4`,
          name: 'Milestone 4',
          percentage: 30,
          amount: (project.p_total_cost || 0) * 0.30,
          status: 'pending',
          description: 'Final touch-ups, verification, and closure of all pending work items.',
          workStage: 'not-started',
          inspectionImages: [],
          inspectionStatus: '',
          pm_inspection_details: {},
          inspectionDisapprovalReason: '',
          activities: [],
        },
      ];
      
    }
  })
}else{
  setMilestones(()=>{
    if (project && project.milestones.length) {
      const baseAmount = parseFloat(
        project.p_total_cost||0
      );
      return project.milestones.map((milestone: any, index: number) => ({
        id: milestone.pm_id,
        name: milestone.pm_name,
        percentage: milestone.pm_percentage,
        amount:  baseAmount * (parseFloat(milestone.pm_percentage) || 0) / 100,
        status:milestone.pm_status,
        description:milestone.pm_description,
        workStage:milestone.pm_work_stage,
        inspectionImages:[],
        inspectionStatus:"",
        pm_inspection_details:milestone.pm_inspection_details,
        inspectionDisapprovalReason:"",
        activities:milestone.activities.map((a:any)=>{
          return {
            id: a.pma_id,
            timestamp:a.pma_timestamp,
            user: a.pma_role,
            role: a.pma_role,
            action: a.pma_action.replace('_'," ").replace("_"," "),
            details: a.pma_details,
            image:a?.pma_related_images||[],
          }
        }),
        
      }));
    } else {
      return loganDraftRef.current?.milestones?.length
        ? toWorkflowMilestones(loganDraftRef.current.milestones, project?.p_total_cost || loganDraftRef.current.costOfProject)
        : [];
    }
  })
}
},[project?.p_escrow ,project?.milestones])



const canUpdateCurrentProject = isContractorUser
  ? !project?.p_id
    ? hasContractPermission(PERMISSIONS.CREATE_CONTRACT)
    : canAccessContractRecord(project, PERMISSIONS.UPDATE_CONTRACT)
  : false;
const isHomeowner = isHomeownerContractOwner(project)
const isEditDisable  = project?.p_id ? !(canUpdateCurrentProject || isHomeowner) : false
const assistantCanEditProjectFields = activeArrowTab === 1 && !isEditDisable && !newUserType && !isProfileBlocking;
const assistantCanEditMilestones = activeArrowTab === 2 && !isEditDisable && project?.p_status !== "LIVE";
const assistantEditableFields = assistantCanEditProjectFields
  ? [
      "projectName", "scope", "homeownerFirstName", "homeownerLastName", "homeownerEmail",
      "homeownerPhone", "homeownerSelection", "address", "city", "state", "zip", "country",
      "costOfProject", "escrow",
    ]
  : assistantCanEditMilestones
    ? [
        "milestones",
        ...(Number(project?.p_escrow) !== 0 ? ["costOfProject"] : []),
      ]
    : activeArrowTab === 4 && contractEditorOpen && !isEditDisable && project?.p_status !== "LIVE"
      ? [
          "governingState", "additionalHomeownerName", "startDate", "substantialCompletionDate", "endDate",
          "projectCostModel", "allowances", "descriptionOfWork", "contractorAuthorizedRepresentative",
          "homeownerAuthorizedRepresentative", "contractorInsurance", "insuranceProviderName",
          "workersCompensationInsurance", "workersCompensationInsuranceLimit", "documentName",
        ]
    : [];
const reviewContractorSigned = Boolean(project?.contract?.pc_contractor_signature_url?.trim());
const reviewHomeownerSigned = Boolean(project?.contract?.pc_homeowner_signature_url?.trim());
const reviewHasContract = Boolean(project?.contract?.pc_id);
const reviewHasDocument = Boolean(project?.contract?.pc_contract_url);
const reviewMilestoneCount = project?.milestones?.length || milestones?.length || 0;
const reviewSubcontractorCount = linkedSubcontractAgreements.length;
const reviewSignedSubcontractorCount = linkedSubcontractAgreements.filter((agreement: any) => agreement.status === "fully_executed").length;
console.log(project)
const reviewProjectCost = project?.p_cost
  ? Number(project.p_cost).toLocaleString("en-US", { minimumFractionDigits: 2 })
  : formData.costOfProject || "0.00";
const reviewItems = [
  {
    label: t("Project Info"),
    description: project?.p_name || formData.projectName || t("Project details are ready."),
    ready: Boolean(project?.p_id),
    icon: ClipboardCheck,
  },
  {
    label: t("Milestones"),
    description: reviewMilestoneCount > 0 ? `${reviewMilestoneCount} ${t("milestone(s) added")}` : t("No milestones added yet."),
    ready: reviewMilestoneCount > 0,
    icon: ClipboardCheck,
  },
  {
    label: t("Subcontractor"),
    description: reviewSubcontractorCount > 0
      ? `${reviewSubcontractorCount} ${t("agreement(s) connected")} · ${reviewSignedSubcontractorCount} ${t("fully signed")}`
      : t("No subcontract agreements connected."),
    ready: true,
    icon: UsersRound,
  },
  {
    label: t("Contract"),
    description: reviewHasDocument ? t("Contract document is ready.") : t("Create the contract before sending."),
    ready: reviewHasContract && reviewHasDocument,
    icon: FileText,
  },
  {
    label: t("Contractor Signature"),
    description: reviewContractorSigned ? t("Signed") : t("Signature pending"),
    ready: reviewContractorSigned,
    icon: UserRound,
  },
  {
    label: t("Homeowner Signature"),
    description: reviewHomeownerSigned ? t("Signed") : t("Signature pending"),
    ready: reviewHomeownerSigned,
    icon: UserRound,
  },
];
const reviewReadyCount = reviewItems.filter((item) => item.ready).length;
const reviewAllReady = reviewItems.every((item) => item.ready);
const assistantMilestoneTotal = Number((milestones || []).reduce((total: number, milestone: any) => total + Number(milestone?.percentage || 0), 0).toFixed(2));
const assistantProjectReady = Boolean((project?.p_id || formData.projectName.trim()) && Number(String(project?.p_cost || formData.costOfProject || "").replace(/,/g, "")) > 0);
const assistantHomeownerReady = Boolean(project?.p_home_owner_id || homeOwnerId);
const assistantLocationReady = Boolean(
  (project?.p_street_address || formData.address.trim()) &&
  (project?.p_city || formData.city.trim()) &&
  (project?.p_state || formData.state.trim()) &&
  (project?.p_zip || formData.zip.trim())
);
const assistantPaymentReady = reviewMilestoneCount > 0 && assistantMilestoneTotal === 100;
const assistantProjectSnapshot: LoganProjectDraft = {
  projectName: formData.projectName || project?.p_name || "",
  scope: assistantScope,
  homeownerFirstName: formData.firstName || "",
  homeownerLastName: formData.lastName || "",
  homeownerEmail: formData.email || "",
  homeownerPhone: formData.phone || "",
  homeownerId: Number(homeOwnerId || project?.p_home_owner_id) || null,
  address: formData.address || "",
  city: formData.city || "",
  state: formData.state || "",
  zip: formData.zip || "",
  country: formData.country || project?.p_country || "",
  costOfProject: String(formData.costOfProject || project?.p_cost || "").replace(/,/g, ""),
  escrow: Boolean(formData.escrow),
  milestones: (milestones || []).map((milestone: any) => ({
    name: milestone.name || milestone.title || "Milestone",
    percentage: Number(milestone.percentage || 0),
    description: milestone.description || "",
  })),
  sourceText: "",
  updatedAt: new Date().toISOString(),
  ...contractTermsSnapshot,
};

const applyAssistantChanges = async (changes: ContractWorkflowChange[]) => {
  const formPatch: Record<string, any> = {};
  let nextScope = assistantScope;
  let nextMilestones = assistantProjectSnapshot.milestones;
  let homeownerIdentityChanged = false;
  changes.forEach((change) => {
    const formFieldMap: Record<string, string> = {
      projectName: "projectName",
      homeownerFirstName: "firstName",
      homeownerLastName: "lastName",
      homeownerEmail: "email",
      homeownerPhone: "phone",
      address: "address",
      city: "city",
      state: "state",
      zip: "zip",
      country: "country",
      costOfProject: "costOfProject",
      escrow: "escrow",
    };
    if (change.field === "scope") nextScope = String(change.value);
    if (change.field === "milestones" && Array.isArray(change.value)) nextMilestones = change.value;
    if ([
      "governingState", "additionalHomeownerName", "startDate", "substantialCompletionDate", "endDate",
      "projectCostModel", "allowances", "descriptionOfWork", "contractorAuthorizedRepresentative",
      "homeownerAuthorizedRepresentative", "contractorInsurance", "insuranceProviderName",
      "workersCompensationInsurance", "workersCompensationInsuranceLimit", "documentName",
    ].includes(change.field)) {
      setContractTermsSnapshot((current) => ({ ...current, [change.field]: change.value }));
    }
    const mappedField = formFieldMap[change.field];
    if (mappedField) {
      formPatch[mappedField] = change.field === "costOfProject" && typeof change.value === "string"
        ? Number(change.value.replace(/,/g, "")).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : change.value;
    }
    if (["homeownerFirstName", "homeownerLastName", "homeownerEmail", "homeownerPhone"].includes(change.field)) homeownerIdentityChanged = true;
  });

  if (homeownerIdentityChanged) setHomeOwnerId("");
  setAssistantScope(nextScope);
  if (nextMilestones !== assistantProjectSnapshot.milestones) {
    setMilestones(toWorkflowMilestones(nextMilestones, formPatch.costOfProject || formData.costOfProject));
  }
  setFormData((current: any) => ({ ...current, ...formPatch }));

  if (formPatch.zip && (!formPatch.city || !formPatch.state || !formPatch.country)) {
    try {
      const response = await fetch(`https://api.zippopotam.us/US/${formPatch.zip}`);
      if (response.ok) {
        const zipData = await response.json();
        const place = zipData?.places?.[0];
        if (place) {
          formPatch.city = formPatch.city || place["place name"]?.replace("City", "").trim() || "";
          formPatch.state = formPatch.state || place["state abbreviation"] || "";
          formPatch.country = formPatch.country || zipData["country abbreviation"] || "US";
          setFormData((current: any) => ({ ...current, ...formPatch }));
        }
      }
    } catch (_error) {
      setNotification({ status: true, message: "ZIP was added, but city and state could not be verified.", variant: "warning" });
    }
  }

  if (!projectId) {
    loganDraftAppliedRef.current = true;
    const fieldToDraft: Record<string, keyof LoganProjectDraft> = {
      projectName: "projectName", firstName: "homeownerFirstName", lastName: "homeownerLastName",
      email: "homeownerEmail", phone: "homeownerPhone", address: "address", city: "city",
      state: "state", zip: "zip", country: "country", costOfProject: "costOfProject", escrow: "escrow",
    };
    const nextDraft: LoganProjectDraft = { ...assistantProjectSnapshot, scope: nextScope, milestones: nextMilestones, updatedAt: new Date().toISOString() };
    Object.entries(formPatch).forEach(([field, value]) => {
      const draftField = fieldToDraft[field];
      if (draftField) (nextDraft as any)[draftField] = value;
    });
    if (homeownerIdentityChanged) nextDraft.homeownerId = null;
    saveLoganProjectDraft(nextDraft);
    loganDraftRef.current = nextDraft;
  }
};

const lookupAssistantHomeowners = async (email: string): Promise<ContractHomeownerMatch[]> => {
  const matches = await dispatch(searchHomeOwner(email));
  return (Array.isArray(matches) ? matches : []).map((homeowner: any) => ({
    id: Number(homeowner.id || homeowner.user_id),
    firstName: homeowner.user_first_name || "",
    lastName: homeowner.user_last_name || "",
    email: homeowner.user_email || "",
    phone: homeowner.user_phone || "",
  })).filter((homeowner: ContractHomeownerMatch) => homeowner.id > 0);
};

const selectAssistantHomeowner = async (homeowner: ContractHomeownerMatch) => {
  const details = await dispatch(getHomeOwnerById(homeowner.id));
  const resolved = Array.isArray(details) && details[0] ? details[0] : null;
  setFormData((current: any) => ({
    ...current,
    firstName: resolved?.user_first_name || homeowner.firstName,
    lastName: resolved?.user_last_name || homeowner.lastName,
    email: resolved?.user_email || homeowner.email,
    phone: resolved?.user_phone || homeowner.phone,
  }));
  setHomeOwnerId(homeowner.id);
};

useEffect(() => {
  localStorage.setItem("loganContractRail.expanded", String(assistantExpanded));
}, [assistantExpanded]);
  return (
    <React.Fragment>
      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {notification.message}
          </Alert>
        </div>
      )}

      <Modal
        show={showProfileWarning}
        onHide={dismissProfileWarning}
        centered
        backdrop="static"
        className="profile-warning-modal"
        aria-labelledby="profile-warning-dialog-title"
      >
        <Modal.Header closeButton>
          <Modal.Title as="h2" id="profile-warning-dialog-title" className="fs-5">
            {t("Profile incomplete")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProfileCompletionGate
            missingFields={missingFields}
            mode="warning"
            title={t("Complete your company profile")}
            description={t("Your company profile is incomplete. You can update it now or continue with this test account.")}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={continueAfterProfileWarning}>
            {t("Continue anyway")}
          </Button>
          <Button variant="primary" onClick={updateCompanyProfile}>
            {t("Update Company Profile")}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className={`page-content contract-flow-page contract-project-workspace ${assistantExpanded ? "has-contract-ai-rail" : "has-contract-ai-rail-collapsed"}`}>
        <Container
          fluid
          style={!isInspectorUser ? {
            width: assistantExpanded ? "calc(100% - var(--contract-ai-rail-width) - 16px)" : "calc(100% - 72px)",
            marginLeft: 0,
            marginRight: "auto",
          } : undefined}
        >
          {loganNavigationDraft && !projectId && (
            <Alert variant="info" className="d-flex align-items-start gap-2">
              <Sparkles size={18} className="flex-shrink-0 mt-1" aria-hidden="true" />
              <div>
                <strong className="d-block">Project details prepared by Logan</strong>
                <span>Review the prefilled Project Info below, then choose Milestones to create the draft project. Nothing has been sent to the homeowner.</span>
              </div>
            </Alert>
          )}
          {termsAccepted &&
            (decoded.userType === "contractor" ||
              decoded.userType === "testContractor") &&
            (userSubscribed && userSubscribed.remainingDays === 0 ? (
              <Alert variant="success">
                <i className="bx bx-spreadsheet align-baseline me-1"></i>
               {t("Your Subscription is live. Thank you for choosing The Tradesmen's Collective.")} {" "}
                <Link to="/contract-tutorial-and-plans">
                {t("Know More or Cancel Plan")}  
                </Link>
              </Alert>
            ) : (
              <Alert variant="danger">
                <i className="bx bx-spreadsheet align-baseline me-1"></i>
                <b>
                {t("You have a complimentary <b>30-day trial period")}</b> 
                {t("to experience this contract service at no cost. Only")}
                
                <b>
                  {userSubscribed && userSubscribed.remainingDays} days left
                </b>
                .{" "}
                <Link to="/contract-tutorial-and-plans">
                 {t("Know More or Cancel Plan")} 
                </Link>
              </Alert>
            ))}
          {workspaceLoading && Boolean(projectId) ? (
            <Card className="border-0 shadow-sm">
              <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: "440px" }}>
                <div className="position-relative mb-4" style={{ width: 64, height: 64 }}>
                  <Spinner animation="border" variant="primary" className="w-100 h-100" role="status" />
                  <FileText
                    size={22}
                    className="position-absolute top-50 start-50 translate-middle text-primary"
                    aria-hidden="true"
                  />
                </div>
                <h4 className="mb-2">{t("Loading contract workspace")}</h4>
                <p className="text-muted mb-0" style={{ maxWidth: 460 }}>
                  {t("Project details and the requested contract step are being prepared. Please wait.")}
                </p>
              </Card.Body>
            </Card>
          ) : projectLoadError && Boolean(projectId) ? (
            <Card className="border-0 shadow-sm">
              <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: "440px" }}>
                <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger-subtle text-danger mb-4" style={{ width: 64, height: 64 }}>
                  <AlertCircle size={30} aria-hidden="true" />
                </span>
                <h4 className="mb-2">{t("Contract couldn't be loaded")}</h4>
                <p className="text-muted mb-4">{t(projectLoadError)}</p>
                <Button variant="primary" onClick={() => setRefresh((value) => !value)}>
                  <Loader2 size={16} className="me-2" /> {t("Try Again")}
                </Button>
              </Card.Body>
            </Card>
          ) : (
          <Row>
            <Col xl={12}>
              <Form  >
              <Card className="contract-workspace-card">
                    <Card.Body className="contract-workspace-body form-steps p-0">
                      <Form action="#">
                        <Tab.Container activeKey={activeArrowTab}>
                          <div className="step-arrow-nav contract-workflow-steps mb-3 overflow-auto">
                            <Nav
                              as="ul"
                              variant="pills"
                              className="custom-nav nav-justified flex-nowrap"
                              style={{ minWidth: isInspectorUser ? "420px" : "720px" }}
                            >
                              <Nav.Item as="li">
                                <Nav.Link
                                  as="button"
                                  type="button"
                                 
                                  eventKey="1"
                                  className={`step-p ${project?.p_id ? "is-complete" : ""}`}
                                  onClick={() =>           onCreateProject(1,projectId)
                                  }
                                >
                                  {t("Project Info")}
                                  
                                </Nav.Link>
                              </Nav.Item>
                     
                              <Nav.Item as="li">
                                <Nav.Link
                                  as="button"
                                  type="button"
                                  eventKey="2"
                                  className={`step-m ${reviewMilestoneCount > 0 ? "is-complete" : ""}`}
                                  disabled={isProfileBlocking}

                                  onClick={() => {
                                    if (activeArrowTab === 2) {
                                      return;
                                    }
                                    if(projectId){
                                      if (activeArrowTab === 1) {
                                        handleUpdateProject()
                                      } else {
                                        onCreateProject(2, projectId)
                                      }
                                    }else{

                                      handleCreateProject()
                                    }
                                  }}
                                >
                               {t("Milestones")}   
                                </Nav.Link>
                              </Nav.Item>

{!isInspectorUser && (isHomeowner ||!isEditDisable ) &&  <Nav.Item as="li">
                                <Nav.Link
                                  as="button"
                                  type="button"
                                  className={`step-home ${reviewHasDocument ? "is-complete" : ""}`}
                                  disabled={isProfileBlocking}

                                  eventKey="4"
                                  onClick={() => {
                                    if(!projectId ){
                                      setError( "Please create project first")
                                      setTimeout(() => {
                                        setError("")
                                      }, 5000);
                                      return
                                      }

                                      if(!project?.milestones[0]){
                                        handleMilestoneSubmit(4)
                                        return
                                      }
                                      onCreateProject(4,projectId)

                                  }
                                  }
                                >
                                 {t("Contract")} 
                                </Nav.Link>
                              </Nav.Item>}
                             
{!isInspectorUser && decoded?.userType !== "homeowner" &&   <Nav.Item as="li">
                                <Nav.Link
                                  as="button"
                                  type="button"
                                  eventKey="3"
                                  className={`step-sub ${reviewSubcontractorCount > 0 || activeArrowTab === 5 ? "is-complete" : ""}`}
                                  disabled={isProfileBlocking}

	                                  onClick={() =>{
	                                    if (activeArrowTab === 2) {
	                                      handleMilestoneSubmit(3)
	                                      return
	                                    }
	                                    onCreateProject(3, projectId)
	                                  }}
                                >
                                  {t("Subcontractor")}
                                  
                                </Nav.Link>
                              </Nav.Item>}
                            

                              <Nav.Item as="li">
                                <Nav.Link
                                  as="button"
                                  type="button"
                                  className={`step-finish ${reviewAllReady ? "is-complete" : ""}`}
                                  disabled={isProfileBlocking}

                                  eventKey="5"
                                  onClick={() =>{
                                    if(!projectId){
                                      setError( "Please create project first")
                                      setTimeout(() => {
                                        setError("")
                                      }, 5000);
                                      return
                                      }
                                      onCreateProject(5,projectId)
                                  }}
                                >
                                  {t("Review")}
                                  
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </div>
                          <Tab.Content>
                          {error && <div className="tailwind-prefix">
        <div style={{
          border:'1px solid red'
        }} className="flex text-red-400 flex-1 mx-3 bg-[#fef3f3] p-1 rounded-sm">
{error}
        </div>
        </div>}
        {successmsg && <div className="tailwind-prefix">
        <div style={{
          border:'1px solid green'
        }} className="flex text-green-700 flex-1 mb-2 bg-green-50 p-1 rounded-sm">
{successmsg}
        </div>
        </div>}
        {missingFields[0] && !showProfileWarning && (
          <ProfileCompletionGate
            missingFields={missingFields}
            mode={isContractProfileTestUser ? "warning" : "blocking"}
            description={isContractProfileTestUser
              ? t("Your company profile is incomplete. You can continue with this test account or update the missing details now.")
              : undefined}
            onUpdateProfile={updateCompanyProfile}
          />
        )}
      
                            <Tab.Pane eventKey="1">
                              {loganNavigationDraft && !projectId && (
                                <Alert variant="info" className="mx-3 mb-3">
                                  <div className="d-flex align-items-start gap-2">
                                    <Sparkles size={18} className="mt-1 flex-shrink-0" aria-hidden="true" />
                                    <div>
                                      <strong>{t("Draft prepared with Logan")}</strong>
                                      <div className="small mt-1">
                                        {loganNavigationDraft.scope || t("Review the prefilled project and homeowner details before continuing.")}
                                      </div>
                                    </div>
                                  </div>
                                </Alert>
                              )}
                              <fieldset
                                className="contract-profile-blocked-content"
                                disabled={isProfileBlocking}
                                aria-describedby={missingFields.length ? "profile-completion-title" : undefined}
                              >
                              <ProjectDetails
                                projectDetails={contData}
                                onCreateProject={onCreateProject}
                                disable={newUserType || isProfileBlocking}
                                setError={setError}
                                error={error}
                                loading={projectLoading}
                                setLoading={setPojectLoading}
                                handleUpdateProject={handleUpdateProject}
                                handleCreateProject={handleCreateProject}
                                bluePrintUrl={bluePrintUrl}
                                formData={formData}
                                scopeOfWork={assistantScope}
                                setScopeOfWork={setAssistantScope}
                                setBluePrintUrl={setBluePrintUrl}
                                setHomeOwnerId={setHomeOwnerId}
                                homeOwnerId={homeOwnerId}
                                setFormData={setFormData}
                                setIsOpen={setIsOpen}
                                setSteps={setSteps}
                                isEditDisable={isEditDisable}
                              />
                              </fieldset>
                            </Tab.Pane>
                            <Tab.Pane eventKey="2">
                              {project &&
                              project.p_escrow !== null &&
                              project.p_escrow == 0 ? (
                           
                                <NewNonEscrow gotoProjectPage={gotoProjectPage} isEscrowProject={isEscrowProject} isEditDisable={isEditDisable} setLoading={setLoading} setRefresh={setRefresh} setContractValue={setContractValue} contractValue={contractValue} project={project} handleMilestoneSubmit={handleMilestoneSubmit}  milestones={milestones}  setMilestones={setMilestones}/>

                              ) : (
                           
                                <NewNonEscrow  gotoProjectPage={gotoProjectPage}isEscrowProject={isEscrowProject} isEditDisable={isEditDisable} setLoading={setLoading} setRefresh={setRefresh} setContractValue={setContractValue} contractValue={contractValue} project={project} handleMilestoneSubmit={handleMilestoneSubmit}  milestones={milestones}  setMilestones={setMilestones}/>

                              )}
                            </Tab.Pane>

                            <Tab.Pane eventKey="3">
                              <HicSubcontractAgreements
                                project={project}
                                onAgreementsChange={setLinkedSubcontractAgreements}
                              />
                              <div className="contract-step-navigation d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-3 mt-4">
                                <Button
                                  variant="light"
                                  className="btn-label previestab w-full sm:w-auto"
	                                  onClick={() => {
	                                   onCreateProject(4,projectId)
	                                  }}
	                                >
	                                  <i className="ri-arrow-left-line label-icon align-middle fs-lg me-2"></i>{" "}
	                                 
	                                 {t("Back to Contract")} 
                                </Button>
                                {(!isEditDisable || isHomeowner ) &&  <Button
                                  variant="primary"
                                  className="btn-label right ms-sm-auto nexttab w-full sm:w-auto"
	                                  onClick={() => {
	                                    onCreateProject(5,projectId)
	                                  }}
	                                >
	                                  <i className="ri-arrow-right-line label-icon align-middle fs-lg ms-2"></i>{" "}
	                                 {t("Review")} 
                                </Button>}
                               
                              </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="4">
                              <Contract
                                projectDetails={contData}
                                disable={newUserType}
                                setSuccessMsg={setSuccessMsg}
                                successmsg={successmsg}
                                onCreateContractRequest={runWithProfileWarning}
                                editorOpen={contractEditorOpen}
                                onEditorStateChange={setContractEditorOpen}
                                assistantSnapshot={contractTermsSnapshot}
                                onAssistantSnapshotChange={handleContractAssistantSnapshotChange}
                              />
                              {!contractEditorOpen && <div className="contract-step-navigation d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-3 mt-4">
                                <Button
                                  variant="light"
                                  className="btn-label previestab w-full sm:w-auto"
	                                  onClick={() => {
	                                    onCreateProject(2,projectId)
	                                  }}
	                                >
	                                  <i className="ri-arrow-left-line label-icon align-middle fs-lg me-2"></i>{" "}
	                                {t("Back to Milestones")}  
                                </Button>
                                <Button
                                  variant="primary"
                                  className="btn-label right ms-sm-auto nexttab w-full sm:w-auto"
	                                  onClick={() => {
	                                    onCreateProject(decoded?.userType === "homeowner" ? 5 : 3,projectId)
	                                  }}
	                                >
	                                  <i className="ri-arrow-right-line label-icon align-middle fs-lg ms-2"></i>{" "}
	                                {t(decoded?.userType === "homeowner" ? "Review" : "Subcontractor")}  
                                </Button>
                              </div>}
                            </Tab.Pane>
                            <Tab.Pane eventKey="5">
                              <div className="tailwind-prefix space-y-4">
                                {!project ? (
                                  <div className="space-y-4">
                                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
                                      <div className="space-y-2">
                                        <div className="h-8 w-56 rounded bg-gray-200 animate-pulse" />
                                        <div className="h-4 w-96 max-w-full rounded bg-gray-100 animate-pulse" />
                                      </div>
                                      <div className="h-10 w-36 rounded bg-gray-100 animate-pulse" />
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                      {[0, 1, 2].map((item) => (
                                        <div key={item} className="rounded-lg border border-gray-200 bg-white p-4">
                                          <div className="h-4 w-28 rounded bg-gray-100 animate-pulse" />
                                          <div className="mt-3 h-7 w-20 rounded bg-gray-200 animate-pulse" />
                                        </div>
                                      ))}
                                    </div>
                                    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                                      <div className="space-y-3">
                                        {[0, 1, 2, 3].map((item) => (
                                          <div key={item} className="h-14 rounded bg-gray-100 animate-pulse" />
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                                      <div>
                                        <div className="text-2xl font-[500] text-gray-900 mb-1">{t("Review")}</div>
                                        <div className="text-sm text-gray-600">
                                          {t("Review the contract setup and confirm what is ready before sending or signing.")}
                                        </div>
                                      </div>
                                      <div className={`inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium ${reviewAllReady ? "bg-green-100 text-green-700" : "bg-orange-100 text-orange-700"}`}>
                                        {reviewAllReady ? <CheckCircle2 className="h-4 w-4" /> : <AlertCircle className="h-4 w-4" />}
                                        {reviewReadyCount}/{reviewItems.length} {t("Ready")}
                                      </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                      <div className="rounded-lg border border-gray-200 bg-white p-4">
                                        <div className="flex items-center gap-2 text-sm text-gray-500">
                                          <ClipboardCheck className="h-4 w-4" />
                                          {t("Project")}
                                        </div>
                                        <div className="mt-2 text-base font-semibold text-gray-900">{project?.p_name || "-"}</div>
                                        <div className="mt-1 text-sm text-gray-500">${reviewProjectCost}</div>
                                      </div>
                                      <div className="rounded-lg border border-gray-200 bg-white p-4">
                                        <div className="flex items-center gap-2 text-sm text-gray-500">
                                          <UserRound className="h-4 w-4" />
                                          {t("Homeowner")}
                                        </div>
                                        <div className="mt-2 text-base font-semibold text-gray-900">{project?.home_owner?.user_first_name || formData.firstName || "-"}</div>
                                        <div className="mt-1 text-sm text-gray-500">{project?.home_owner?.user_email || formData.email || "-"}</div>
                                      </div>
                                      <div className="rounded-lg border border-gray-200 bg-white p-4">
                                        <div className="flex items-center gap-2 text-sm text-gray-500">
                                          <FileText className="h-4 w-4" />
                                          {t("Contract")}
                                        </div>
                                        <div className={`mt-2 inline-flex rounded px-2 py-1 text-sm font-medium ${reviewHasDocument ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-700"}`}>
                                          {reviewHasDocument ? t("Document Ready") : t("Not Created")}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                                      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-4">
                                        <div>
                                          <div className="text-base font-semibold text-gray-900">{t("Final Checklist")}</div>
                                          <div className="text-sm text-gray-500">{t("Items marked pending should be completed before the contract is considered ready.")}</div>
                                        </div>
                                      </div>
                                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        {reviewItems.map((item) => {
                                          const Icon = item.icon;
                                          return (
                                            <div key={item.label} className="flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 p-3">
                                              <div className={`mt-0.5 flex h-9 w-9 items-center justify-center rounded-md ${item.ready ? "bg-green-100 text-green-700" : "bg-orange-100 text-orange-700"}`}>
                                                <Icon className="h-4 w-4" />
                                              </div>
                                              <div className="min-w-0 flex-1">
                                                <div className="flex items-center justify-between gap-2">
                                                  <div className="text-sm font-medium text-gray-900">{item.label}</div>
                                                  <span className={`shrink-0 rounded px-2 py-0.5 text-xs font-medium ${item.ready ? "bg-green-100 text-green-700" : "bg-orange-100 text-orange-700"}`}>
                                                    {item.ready ? t("Ready") : t("Pending")}
                                                  </span>
                                                </div>
                                                <div className="mt-1 text-sm text-gray-600">{item.description}</div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>

                                    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                                      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                        <div>
                                          <div className="text-base font-semibold text-gray-900">
                                            {reviewAllReady ? t("Contract is ready") : t("Contract still needs attention")}
                                          </div>
                                          <div className="text-sm text-gray-500">
                                            {reviewAllReady
                                              ? t("All required contract steps are complete.")
                                              : t(isInspectorUser ? "Go back to the Milestones tab to review project progress." : "Go back to the Contract tab to create, send, or sign the contract.")}
                                          </div>
                                        </div>
                                        <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
                                          <button
                                            type="button"
                                            onClick={() => onCreateProject(isInspectorUser ? 2 : 4, projectId)}
                                            className="inline-flex w-full sm:w-auto items-center justify-center rounded-md border border-gray-300 bg-white px-3 py-[9px] text-[13px] font-medium text-gray-700 hover:bg-gray-50"
                                          >
                                            <FileText className="mr-2 h-4 w-4" />
                                            {t(isInspectorUser ? "Back to Milestones" : "Back to Contract")}
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => navigate("/get-contracts")}
                                            className="inline-flex w-full sm:w-auto items-center justify-center rounded-md border-0 bg-[#2563EB] px-3 py-[9px] text-[13px] font-medium text-white hover:bg-[#1D4ED8]"
                                          >
                                            <Send className="mr-2 h-4 w-4" />
                                            {reviewAllReady ? t("Go to Contracts") : t("View Dashboard")}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </Tab.Pane>

                          </Tab.Content>
                        </Tab.Container>
                      </Form>
                    </Card.Body>
                  </Card>
              </Form>
            </Col>
          </Row>
          )}
      <Toaster position="top-right" richColors />

        </Container>
        {!isInspectorUser && (
          <ContractAssistantRail
            expanded={assistantExpanded}
            autoFocus={shouldFocusLoganChat}
            initialContext={loganContractContext}
            activeStep={activeArrowTab}
            projectId={projectId}
            projectName={project?.p_name || formData.projectName}
            projectReady={assistantProjectReady}
            homeownerReady={assistantHomeownerReady}
            locationReady={assistantLocationReady}
            paymentReady={assistantPaymentReady}
            milestoneCount={reviewMilestoneCount}
            milestoneTotal={assistantMilestoneTotal}
            hasContractRecord={reviewHasContract}
            hasContractDocument={reviewHasDocument}
            contractorSigned={reviewContractorSigned}
            homeownerSigned={reviewHomeownerSigned}
            editableFields={assistantEditableFields}
            projectSnapshot={assistantProjectSnapshot}
            contractEditorOpen={contractEditorOpen}
            onApplyChanges={applyAssistantChanges}
            onLookupHomeowners={lookupAssistantHomeowners}
            onSelectHomeowner={selectAssistantHomeowner}
            onSaveAndContinue={() => {
              if (activeArrowTab === 1) {
                return projectId ? handleUpdateProject() : handleCreateProject();
              }
              if (activeArrowTab === 2) return handleMilestoneSubmit(4);
            }}
            onOpenContractEditor={() => runWithProfileWarning(() => setContractEditorOpen(true))}
            onExpandedChange={setAssistantExpanded}
            onNavigate={(step) => onCreateProject(step, projectId)}
          />
        )}
      </div>

    </React.Fragment>
  );
};

function toWorkflowMilestones(suggestions: LoganProjectDraft["milestones"], totalCost: string | number) {
  const baseAmount = Number(String(totalCost || 0).replace(/,/g, "")) || 0;
  return suggestions.map((milestone, index) => ({
    id: `logan-${Date.now()}-${index}`,
    name: milestone.name,
    title: milestone.name,
    percentage: milestone.percentage,
    amount: baseAmount * (milestone.percentage / 100),
    status: "pending",
    description: milestone.description,
    workStage: "not-started",
    inspectionImages: [],
    inspectionUrl: "",
    inspectionStatus: "",
    pm_inspection_details: {},
    inspectionDisapprovalReason: "",
    isDisable: false,
    isCompleted: false,
    activities: [],
  }));
}

function toDateInputValue(value: unknown) {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(String(value));
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
}

export default CreateProject;
